module.exports = __webpack_public_path__ + "static/media/2.60da8617.png";